// A hint line that swaps its text between keyboard and controller prompts when the active
// input device changes. Self-subscribing; used by the start / draft / game-over screens.

import { getInputMode, onInputMode } from '../core/inputMode';

/** Green Xbox "A" button glyph for inline hint text. */
export const A_BTN = '<span style="color:#6abf4b">A</span>';

export function adaptiveHint(keyboardHtml: string, gamepadHtml: string): HTMLDivElement {
  const el = document.createElement('div');
  const apply = (): void => {
    el.innerHTML = getInputMode() === 'gamepad' ? gamepadHtml : keyboardHtml;
  };
  apply();
  onInputMode(apply);
  return el;
}
